import React from "react";

function AboutUs() {
  return (
    <>
    
      {/* Facts Start */}
      <div className="container-fluid facts py-5 pt-lg-0">
        <div className="container py-5 pt-lg-0">
          <div className="row gx-0">
            <div className="col-lg-3 wow zoomIn" data-wow-delay="0.1s">
              <div className="bg-primary shadow d-flex" style={{height: "250px"}}>
                <div className="p-4">
                  <div className="d-flex">
                    <div
                      className="h-90 bg-white d-flex align-items-center justify-content-center rounded-2 mb-4"
                      style={{width: "100px", height: "60px"}}>
                      <i className="fa fa-users text-primary fs-2"></i>
                    </div>
                    <h5
                      className="text-white fs-9 mb-0 fw-bold w-500 align-self-start pt-1"
                      style={{marginLeft: "8px"}}
                    >
                      Search Engine Optimization (SEO)
                    </h5>
                  </div>
                  <p
                    className="mb-5 text-white"
                    style={{
                      fontSize: "17px",
                      fontWeight: "normal",
                      marginRight: "15px"
                    }}
                  >
                    We are SEO Specialists, we can bring your business in the top
                    SERP (Search Engines Results Page).
                  </p>
                  {/* <h1 className="text-white mb-0" data-toggle="counter-up">0</h1> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 wow zoomIn" data-wow-delay="0.3s">
              <div className="bg-body shadow d-flex" style={{height: "250px"}}>
                <div className="p-4">
                  <div className="d-flex">
                    <div
                      className="h-90 bg-info d-flex align-items-center justify-content-center rounded-2 mb-3"
                      style={{width: "100px", height: "60px"}}>
                      <i className="fas fa-ad text-white fs-2"></i>
                    </div>
                    <h5
                      className="text-info fs-9 mb-0 fw-bold w-500 align-self-start pt-1"
                      style={{marginLeft: "8px"}}>
                      Search Engine Marketing (SEM)
                    </h5>
                  </div>
                  <p
                    className="mb-5 text-black"
                    style={{fontSize: "17px", fontWeight: "normal"}}>
                    We handle the content marketing, promotions, and help you in
                    Online Branding.
                  </p>
                  {/* <h1 className="text-white mb-0" data-toggle="counter-up">0</h1> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 wow zoomIn" data-wow-delay="0.1s">
              <div className="bg-primary shadow d-flex" style={{height: "250px"}}>
                <div className="p-4">
                  <div className="d-flex">
                    <div
                      className="h-90 bg-white d-flex align-items-center justify-content-center rounded-2 mb-3"
                      style={{width: "100px", height: "60px"}}>
                      <i className="fas fa-thumbs-up text-primary fs-2"></i>
                    </div>
                    <h5
                      className="text-white fs-9 mb-0 fw-bold w-500 align-self-start pt-1"
                      style={{marginLeft: "8px"}}>
                      Social Media Optimization (SMO)
                    </h5>
                  </div>
                  <p
                    className="mb-5 text-white"
                    style={{fontSize: "17px", fontWeight: "normal"}}>
                    We help in optimizing through all social media platforms
                    including video channels.
                  </p>
                  {/* <h1 className="text-white mb-0" data-toggle="counter-up">0</h1> */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 wow zoomIn" data-wow-delay="0.3s">
              <div className="bg-light shadow d-flex" style={{height: "250px"}}>
                <div className="p-4">
                  <div className="d-flex">
                    <div
                      className="h-90 bg-info d-flex align-items-center justify-content-center rounded-2 mb-3"
                      style={{width: "100px", height: "60px"}}>
                      <i className="fas fa-share-alt text-white fs-2"></i>
                    </div>
                    <h5
                      className="text-primary fs-9 mb-0 fw-bold w-500 align-self-start pt-1"
                      style={{marginLeft: "8px"}}>
                      Social Media Marketing (SMM)
                    </h5>
                  </div>
                  <p
                    className="mb-5 text-black"
                    style={{fontSize: "17px", fontWeight: "normal"}}>
                    We help in promoting products or services targeting all social
                    media platforms to drive the traffic and increase sales.
                  </p>
                  {/* <h1 className="text-white mb-0" data-toggle="counter-up">0</h1> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Facts Start */}

      {/* About Start */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-7">
              <div className="section-title position-relative pb-3 mb-5">
                <h5 className="fw-bold text-primary text-uppercase">About Us</h5>
                <h1 className="mb-0">
                  Offering Digital Marketing Solutions with 8+ Years of Experience
                </h1>
              </div>
              <p className="mb-4 fs-5">
                Welcome to Brand Lift, we are your trusted advisors and a
                leading team of branding experts, we understand the complexities
                of the digital world and ensure that your business grows with our
                tailored solutions that suit your unique goals.
              </p>
              <div className="row g-0 mb-3">
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Award Winning
                  </h5>
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Professional
                    Staff
                  </h5>
                </div>
                <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>24 x 7 Support
                  </h5>
                  <h5 className="mb-3">
                    <i className="fa fa-check text-primary me-3"></i>Fair Prices
                  </h5>
                </div>
              </div>

              <div
                className="d-flex align-items-center mb-4 wow fadeIn"
                data-wow-delay="0.6s"
              >
                <div
                  className="bg-primary d-flex align-items-center justify-content-center rounded"
                  style={{width: "60px", height: "60px"}}>
                  <i className="fa fa-phone-alt text-white fs-2"></i>
                </div>
                <div className="ps-4">
                  <h5 className="mb-2">Call to ask any question</h5>
                  <h4 className="text-primary mb-0">+971 55 730 6504</h4>
                </div>
              </div>
              <a
                href="/free-quote"
                className="btn btn-primary py-3 px-5 mt-3 wow zoomIn"
                data-wow-delay="0.9s"
                >Request A Quote</a
              >
            </div>
            <div className="col-lg-5" style={{minHeight: "500px"}}>
              <div className="position-relative h-100">
                <img
                  className="position-absolute w-100 h-100 rounded wow zoomIn"
                  data-wow-delay="0.9s"
                  src="/img/about us (440 x 543).jpg"
                  alt="About Us"
                  style={{objectFit: "cover"}}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* About End */}
    </>
  );
}

export default AboutUs;
